import { render, staticRenderFns } from "./VerticalActions.vue?vue&type=template&id=594a6254"
import script from "./VerticalActions.vue?vue&type=script&lang=js"
export * from "./VerticalActions.vue?vue&type=script&lang=js"
import style0 from "../assets/scss/components/_verticalActions.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports